"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconTypeOfBuilding = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 22",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,19.5 L0,8.5 L7.5,3.5 L15,8.5 L15,19.5 L10,19.5 L10,12.5 L5,12.5 L5,19.5 L0,19.5 M24,0.5 L24,19.5 L17,19.5 L17,7.43 L16,6.77 L16,4.5 L14,4.5 L14,5.43 L10,2.77 L10,0.5 L24,0.5 M21,12.5 L19,12.5 L19,14.5 L21,14.5 L21,12.5 M21,8.5 L19,8.5 L19,10.5 L21,10.5 L21,8.5 M21,4.5 L19,4.5 L19,6.5 L21,6.5 L21,4.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconTypeOfBuilding')(IconTypeOfBuilding);